<template>
    <Modal class="speakers-modal" @closed="$emit('close')">
        <div class="speakers-modal__inner">
            <PaginatedResource
                ref="speakersRes"
                :fetch-method="fetchSpeakersPage"
                :filter-fields="['book_language', 'language', 'limits']"
            >
                <template
                    #default="{ loading, resource: speakers, canLoadMore, loadMore, isEmpty, filter }"
                >
                    <div>
                        <div class="speakers-modal__top">
                            <LanguageSelect
                                :model-value="langObject.slug"
                                :languages="languages"
                                delay-fetch
                                @select="
                                    filter({
                                        language: $event.item.id,
                                        book_language: !$event.item.id
                                            ? $event.item.slug
                                            : undefined
                                    })
                                "
                            />
                        </div>
                        <div class="speakers-modal__list">
                            <Spinner v-if="loading" />

                            <SpeakerCard
                                v-for="sp in speakers"
                                :key="sp.id"
                                :speaker="sp"
                                class="speaker-modal__card"
                                @click="$emit('update:modelValue', sp)"
                            />
                        </div>
                        <div v-if="canLoadMore" class="speakers-modal__loadmore">
                            <button type="button" class="button button--blank" @click="loadMore">
                                Load more
                            </button>
                        </div>
                    </div>
                </template>
            </PaginatedResource>
        </div>
    </Modal>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import LanguageSelect from '@speechki-frontend/shared/ui/LanguageSelect';
import SpeakerCard from '@speechki-frontend/shared/ui/SpeakerCard/SpeakerCard';

import { fetchSpeakersPage } from '../../api/speakers';
import { fetchLanguages } from '../../api/books';

export default {
    name: 'SpeakersModal',
    components: {
        Modal,
        PaginatedResource,
        LanguageSelect,
        SpeakerCard
    },
    emits: ['close', 'update:modelValue'],
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        limit: {
            type: Number,
            default: undefined
        },
        language: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            languages: []
        };
    },
    computed: {
        langObject() {
            let result = {};

            this.languages.forEach(base => {
                if (base.languages) {
                    base.languages.forEach(lang => {
                        if (lang.id === this.language) {
                            result = lang;
                        }
                    });
                }
            });

            return result;
        }
    },
    async created() {
        await this.fetchLanguages();
        this.$nextTick(() => {
            this.$refs.speakersRes.filter({
                language: this.langObject.id,
                limits: this.limit
            });
        });
    },
    methods: {
        fetchSpeakersPage,
        async fetchLanguages() {
            this.languages = await fetchLanguages();
        }
    }
};
</script>

<style lang="scss" src="./SpeakersModal.scss"></style>
